import React, { useState } from 'react';
import ConfirmCancelFormEditModal from '../modals/ConfirmCancelFormEditModal';

const withConfirmCancelFormEditModal = (Component) => {
  const ConfirmCancelFormEditModalComponent = (props) => {
    const { isChange, onCloseFormEditItemExpandable } = props || {};

    const [
      isShowConfirmCancelFormEditModal,
      setShowConfirmCancelFormEditModal,
    ] = useState(false);

    const handleOnShowConfirmCancelFormEditModal = () => {
      if (isChange) {
        setShowConfirmCancelFormEditModal(true);
        return;
      }
      onCloseFormEditItemExpandable();
    };
    const handleOnCloseConfirmCancelFormEditModal = () => {
      setShowConfirmCancelFormEditModal(false);
    };
    const handleConfirmCancelFormEditAction = () => {
      onCloseFormEditItemExpandable();
      handleOnCloseConfirmCancelFormEditModal();
    };
    const handleConfirmCancelFormEditActionClose = () => {
      handleOnCloseConfirmCancelFormEditModal();
    };
    const renderConfirmCancelFormEditModal = () => {
      if (!isShowConfirmCancelFormEditModal) return null;
      return (
        <ConfirmCancelFormEditModal
          isShow={isShowConfirmCancelFormEditModal}
          action={handleConfirmCancelFormEditAction}
          actionClose={handleConfirmCancelFormEditActionClose}
        />
      );
    };

    const newProps = {
      ...props,
      onShowConfirmCancelFormEditModal: handleOnShowConfirmCancelFormEditModal,
    };
    return (
      <>
        {renderConfirmCancelFormEditModal()}
        <Component {...newProps} />
      </>
    );
  };
  return ConfirmCancelFormEditModalComponent;
};

export default withConfirmCancelFormEditModal;
